import script from "./InvoiceStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceStatCard.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceStatCard.vue?vue&type=style&index=0&id=c550b622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c550b622"]])

export default __exports__